import without from 'lodash/without'

import {
  SERVICINGS_SUCCESS,
  DELETE_SERVICING_SUCCESS
} from '../actions/servicings'

import {
  FETCH_WORK_ORDER_COMMENTS_SUCCESS
} from '../actions/comments'

import {
  FETCH_WORK_ORDER_MESSAGES_SUCCESS,
  FETCH_WORK_ORDER_UNREAD_MESSAGES_SUCCESS,
  CREATE_WORK_ORDER_MESSAGE_SUCCESS
} from '../actions/messages'

import {
  WORK_ORDER_SUMMARIES_SUCCESS
} from '../actions/service-summaries'

import {
  WORK_ORDER_WORK_AREA_SUMMARIES_SUCCESS
} from '../actions/work-area-summaries'

import {
  DELETE_MESSAGE_SUCCESS
} from '../actions/messages'

export default function (state = {}, action) {
  switch (action.type) {
    case SERVICINGS_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          servicings: action.payload.result,
          finishedLoadingServicings: true,
        }
      }

    case WORK_ORDER_SUMMARIES_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          serviceSummaries: action.payload.result
        }
      }

    case WORK_ORDER_WORK_AREA_SUMMARIES_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          workAreaSummaries: action.payload.result
        }
      }

    case FETCH_WORK_ORDER_COMMENTS_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          comments: action.payload.result
        }
      }

    case FETCH_WORK_ORDER_MESSAGES_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          messages: action.payload.result
        }
      }

    case FETCH_WORK_ORDER_UNREAD_MESSAGES_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          unreadMessages: action.payload.result
        }
      }

    case CREATE_WORK_ORDER_MESSAGE_SUCCESS:
      return {
        ...state,
        [action.payload.workOrderId]: {
          ...state[action.payload.workOrderId],
          messages: [action.payload.result, ...(state[action.payload.workOrderId].messages || [])],
          unreadMessages: [
            action.payload.result,
            ...(state[action.payload.workOrderId].unreadMessages || [])
          ]
        }
      }

    case DELETE_SERVICING_SUCCESS:
      return removeServicingFromEveryWorkOrder(state, action.payload.resourceId)

    case DELETE_MESSAGE_SUCCESS:
      return removeMessageFromEveryWorkOrder(state, action.payload.resourceId)

    default:
      return state
  }
}

function removeServicingFromEveryWorkOrder (state, servicingId) {
  Object.keys(state).forEach(workOrderId => {
    state = {
      ...state,
      [workOrderId]: {
        ...state[workOrderId],
        servicings: without(state[workOrderId].servicings || [], servicingId)
      }
    }
  })

  return state
}

function removeMessageFromEveryWorkOrder (state, messageId) {
  Object.keys(state).forEach(workOrderId => {
    state = {
      ...state,
      [workOrderId]: {
        ...state[workOrderId],
        unreadMessages: without(state[workOrderId].unreadMessages || [], messageId),
        messages: without(state[workOrderId].messages || [], messageId)
      }
    }
  })

  return state
}



// WEBPACK FOOTER //
// ./src/reducers/work-orders.js